"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInterfaceUris = void 0;
var __1 = require("../");
exports.coreInterfaceUris = {
    uriResolver: new __1.Uri("w3://ens/uri-resolver.core.web3api.eth"),
    logger: new __1.Uri("w3://ens/logger.core.web3api.eth"),
};
//# sourceMappingURL=core-interface-uris.js.map